module.exports = __webpack_public_path__ + "media/24.1272ce38.mp3";